import React from 'react';
import { useIntl } from 'react-intl';
import { Spin } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding-top: 21em;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1111;
`;
const Loading = styled.div`
  width: 0;
  margin: auto;
`;

const PageLoader = ({ gps }) => {
  if (!gps.fetching) return null;

  const intl = useIntl();
  const textLoading = `${intl.formatMessage({
    id: 'Loading',
    defaultMessage: 'Loading',
  })}...`;

  return (
    <Wrapper>
      <Loading>
        <Spin size="large" tip={textLoading} />
      </Loading>
    </Wrapper>
  );
};

export default PageLoader;
